export default function Profile() {
  return (
    <section id="profile" className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-[#4A5568] text-xs font-bold tracking-widest uppercase mb-4">PROFILE</p>
          <h3 className="text-xl font-bold text-[#1A3A5C] mb-2">代表：山本 彬</h3>
          <p className="text-[#4A5568] text-sm">製造業×AI開発を専門とするエンジニアが、<br />課題ヒアリングから現場に合ったソリューションの提案・実装・導入まで一貫対応します。</p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-center gap-16">
            <div className="flex-shrink-0 w-full md:w-80 h-80">
              <img
                src="/assets/profile.jpg"
                alt="製造業×AI"
                className="w-full h-full object-cover object-top rounded-2xl shadow-lg"
              />
            </div>
            <div className="space-y-6 text-[#4A5568] text-base leading-relaxed mb-10 md:mb-0">
              <p>
                大手製造業で10年以上、設計開発・生産技術の現場で働いてきました。鍛造・切削工程の立上げや製造現場のDX推進に従事する中で、「現場の課題をどう解決するか」を問い続けてきました。
              </p>
              <p>
                その後、製造業向けシステム開発を手がけるSIerにて製造現場DXに携わり、続いてAI開発に特化したスタートアップにて大手メーカーのAI-PoC・開発プロジェクトを複数担当。要件定義から実装・納品まで一貫して対応してきました。
              </p>
              <p>
                製造現場とAI開発の両方を知るエンジニアとして、技術ありきではなく、課題ありきで、現場目線の最適なAI活用を提案したい。その思いでEngiMindを立ち上げました。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
